import { useQuery } from "@apollo/client/react";
import paths from "config/routePaths";
import { GetUsers } from "hooks/apollo/user/user.gql";
import Authorization from "policies/Authorization";
import React from "react";
import UserIndexView from "./UserIndexView";

export default function UserIndexContainer() {
  const { data, loading } = useQuery(GetUsers);
  const policy = Authorization.usePolicy();

  if (loading) return null;

  const canCreateUser = policy.canCreate(Authorization.EntityTypes.User);
  const canUpdateCompany = policy.canUpdate(Authorization.EntityTypes.Company);
  const createUserPath = paths.userNew;

  const { users } = data;

  return (
    <UserIndexView
      canCreateUser={canCreateUser}
      canUpdateCompany={canUpdateCompany}
      createUserPath={createUserPath}
      users={users}
    />
  );
}
